import React, { useState, useEffect, useMemo } from "react";
import { useApolloClient } from "@apollo/client";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import {
  GET_WORK_ORDER_BY_ID,
  GET_STATE_BY_NAME,
  UPDATE_WORK_ORDER_,
} from "./QueryWorkOrder";
import RotatingLoopIcon from "scenes/utils/RotatingLoopIcon"
import { WORK_ASSIGN_YUP } from "./YupValidation";
import { FormHelperText } from "@mui/material";
const AssignWorkOrderWait = ({ id, params }) => {
  const {
    setAlertCustom,
    alertCustom,
    setNewAssignRequeriment,
    handleCloseModal,
  } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [itemRequeriment, setItemRequeriment] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const formikAssign = useFormik({
    initialValues: {
      state: "",
    },
    validationSchema: WORK_ASSIGN_YUP,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      const { state } = values;
      try {
        const response = await client.mutate({
          mutation: UPDATE_WORK_ORDER_,
          variables: {
            updateWorkOrderStateId: id,
            state: state,
            active: [],
            date: null,
            timeBegin: null,
            timeEnd: null,
          },
        });
        setNewAssignRequeriment(response.data.createMaintanceRequeriment);
        handleCloseModal();
        resetForm();
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });
  useEffect(() => {
    const getItemRequeriment = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_WORK_ORDER_BY_ID,
          fetchPolicy: "network-only",
          variables: {
            getWorkOrderByIdId: id,
          },
        });
        console.log(data.getWorkOrderById);
        setItemRequeriment(data.getWorkOrderById);
        console.log(itemRequeriment?.state);

        setvisibility(true);
      } catch (error) {
        console.log(error.message);
      }
    };
    const getStateByName = async () => {
      try {
        const { data } = await client.query({
          query: GET_STATE_BY_NAME,
          fetchPolicy: "network-only",
          variables: {
            name: "EN ESPERA DE PLANIFICACION",
            current: "PLANIFICADA",
          },
        });
        console.log(data.getStateByName);
        setStates(data.getStateByName);
      } catch (error) {
        console.log(error.message);
      }
    };
    getItemRequeriment(id);
    getStateByName();
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        {" "}
        <form onSubmit={formikAssign.handleSubmit}>
          <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(2, 1fr)"
            gap="20px"
          >
            <Box sx={style}>
              <label for="my-input">FECHA DE REQUERIMENTO</label>
              <TextField
                disabled
                value={new Date(
                  itemRequeriment?.requeriment.date
                ).toLocaleDateString("es-ES")}
              />
            </Box>
            <Box sx={style}>
              <label for="my-input">PRIORIDAD DE REQUERIMIENTO</label>
              <TextField
                disabled
                value={itemRequeriment?.requeriment.priority.description}
              />
            </Box>
            <Box sx={style}>
              <label for="my-input">TIPO DE REQUERIMIENTO</label>
              <TextField
                disabled
                value={itemRequeriment?.requeriment.type.description}
              />
            </Box>
            <Box sx={style}>
              <label for="my-input">COMENTARIO DE REQUERIMIENTO</label>
              <TextField
                disabled
                value={itemRequeriment?.requeriment.comment}
              />
            </Box>
            <Box sx={style}>
              <label for="my-input">DESCRIPCION</label>
              <TextField                              
              />
            </Box>
            <Box sx={style}>
              <label for="my-input">KILOMETRATE</label>
              <TextField                              
              />
            </Box>
            <Box>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">ESTADO</InputLabel>
                <Select
                  id="state"
                  value={formikAssign.values.state}
                  name="state"
                  onChange={formikAssign.handleChange}
                  label="ESTADO"
                >
                  {states?.map((option) => {
                    return (
                      <MenuItem key={option.id} value={option.id}>
                        {option.description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              {formikAssign.touched.state && formikAssign.errors.state ? (
                <FormHelperText
                  sx={{ color: "#bf3333", marginLeft: "16px !important" }}
                >
                  <p
                    style={{
                      border: "1px solid",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  >
                    {" "}
                    {formikAssign.touched.state && formikAssign.errors.state}
                  </p>
                </FormHelperText>
              ) : null}
            </Box>
         
            {/* <Box sx={style}>
            <label for="my-input">ESTADO</label>
            <TextField disabled value={itemRequeriment?.state.description} />
          </Box> */}
            {itemRequeriment?.date && (
              <Box sx={style}>
                <label for="my-input">FECHA</label>
                <TextField disabled value={itemRequeriment?.date} />
              </Box>
            )}
            {itemRequeriment?.timeBegin && (
              <Box sx={style}>
                <label for="my-input">HORA DE INICIO</label>
                <TextField disabled value={itemRequeriment?.timeBegin} />
              </Box>
            )}
            {itemRequeriment?.timeEnd && (
              <Box sx={style}>
                <label for="my-input">HORA DE FIN</label>
                <TextField disabled value={itemRequeriment?.timeEnd} />
              </Box>
            )}
          </Box>
          <Box mt={"25px"} display={"flex"} justifyContent={"end"}>
            <Button variant="contained" color="success" type="submit" disabled={formikAssign.isSubmitting}>
            {formikAssign.isSubmitting ?<RotatingLoopIcon/>: "GUARDAR"}
            </Button>
          </Box>
        </form>{" "}
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><RotatingLoopIcon/></Box>
  );
};

export default AssignWorkOrderWait;
